import { lazy, Suspense } from "react";
import { PageSkeleton } from "../customs/skeleton/main";

const Main = lazy(() => import("../components/readyToMarket/main"));

const ReadyToMarket = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default ReadyToMarket;

